module.exports = __webpack_public_path__ + "img/poster-video-light-towers.407d7c60.jpg";